<template>
  <div
    class="Footer flex flex-col bg-qwray"
    style="grid-row: var(--footer-row);"
    :country="entity"
  >
    <div class="mt-10 flex flex-col items-center">
      <div><img src="~@/assets/logo.svg" /></div>
      <div class="text-white mt-2 tracking-1px">
        {{ $t('footer.slogan') }}
      </div>
      <ChangeCountryOption :dispatch="dispatch" />
    </div>
    <div class="FooterItems mt-10  mx-10">
      <footer-item
        v-for="(block, index) in linkBlocks"
        v-bind:name="block.name"
        v-bind:key="index"
        v-bind:links="block.links"
        v-bind:last="index == linkBlocks.length - 1"
      ></footer-item>
    </div>
    <div class="flex flex-col items-center">
      <div class="customer-title contact-title text-16px mt-8">
        {{ $t('footer.available') }}
      </div>
      <div
        class="customer-phone contact-item text-qwray flex mt-2 text-14px py-2 px-5 rounded-full min-width"
      >
        <img
          class="pr-2"
          src="~@/assets/footer/footer_phone.svg"
          alt="A phone icon"
        />
        <a
          class="Phone"
          :href="
            `tel:${customerPhone
              .split(' ')
              .filter(Boolean)
              .join('')}`
          "
          >{{ customerPhone }}</a
        >
      </div>
      <span
        class="contact-title text-16px mt-8"
        v-if="shouldShowBusinessNumber"
        >{{ $t('footer.contact-title') }}</span
      >
      <div
        v-if="shouldShowBusinessNumber"
        class="contact-item text-qwray flex mt-3 text-14px py-2 px-5 rounded-full min-width"
      >
        <img
          class="pr-2"
          src="~@/assets/footer/footer_phone.svg"
          alt="A mail icon"
        />
        <a
          class="Phone"
          :href="
            `tel:${businessPhone
              .split(' ')
              .filter(Boolean)
              .join('')}`
          "
          >{{ businessPhone }}</a
        >
      </div>
    </div>
    <hr style="border: #5E7177 1px solid; margin: 37px 0;" />
    <div class="text-qwraybright text-center mt-10 mb-8">
      {{ $t('footer.copyright') }}
    </div>
  </div>
</template>

<script>
import i18n from '@/i18n';
import linkBl from '@/data/footer';
import { entity } from '@/../region.json';
import FooterItem from './FooterItem.vue';
import ChangeCountryOption from '../components/shared/ChangeCountryOption.vue';
import {
  getLinkBlocks,
  shouldShowBusinessNumber,
} from '../shared/entityHelpers';

export default {
  props: ['dispatch'],
  components: {
    FooterItem,
    ChangeCountryOption,
  },
  name: 'Footer',
  data() {
    return {
      entity,
      linkBlocks: getLinkBlocks(linkBl, this.$i18n.locale),
      customerPhone: i18n.t('contact.support_phone'),
      businessPhone: i18n.t('footer.phone'),
    };
  },
  computed: {
    shouldShowBusinessNumber,
  },
};
</script>

<style scoped>
.Footer[country='NETHERLANDS'] .customer.contact-title {
  display: none;
}
.Footer[country='NETHERLANDS'] .customer-title {
  display: none;
}
.Footer[country='NETHERLANDS'] .customer-phone {
  display: none;
}
.Phone {
  white-space: nowrap;
}
.contact-title {
  color: #a1b1b5;
}
.contact-item {
  border: 1px solid white;
  color: white;
}

.min-width {
  min-width: 204px;
}
</style>
